// extracted by mini-css-extract-plugin
module.exports = {"hello":"HelloWorldOptions_hello_10WVs"};